import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as Drop from 'tether-drop';

@Component({
  selector: 'app-ph-drop',
  templateUrl: './ph-drop.component.html',
  styleUrls: ['./ph-drop.component.scss'],
})
export class PhDropComponent implements OnInit {
  dropInstance: Drop;
  @ViewChild('phDropTarget', { static: true }) phDropTarget: ElementRef;
  @ViewChild('phDropContent', { static: true }) phDropContent: ElementRef;
  @Input() position: string = 'top center';
  @Input() classes: string = '';
  @Input() additionalOptions: any = null;
  @Input() constrainToScrollParent: boolean = true;
  disabledClick: boolean = false;

  constructor() {}

  ngOnInit() {
    this.dropInstance = new Drop({
      target: this.phDropTarget.nativeElement,
      content: this.phDropContent.nativeElement,
      position: this.position,
      classes: this.classes,
      remove: true,
      constrainToScrollParent: this.constrainToScrollParent,
      constrainToWindow: true,
      ...this.additionalOptions,
    });
    // fromEvent(this.phDropTarget.nativeElement, 'touchstart')
    //   .pipe(
    //     map((event: any) => {
    //       return event.target.value;
    //     })
    //   ).subscribe(this.disableClick.bind(this));
    //
    // this.dropInstance.on('close', () => {
    //   setTimeout(() => {
    //     this.enableClick();
    //   }, 150);
    // });
  }

  disableClick() {
    if (this.disabledClick) {
      return;
    }
    this.disabledClick = true;
    if (window.addEventListener) {
      this.phDropTarget.nativeElement.addEventListener('touchend', this.preventDefault, {
        passive: false,
      });
      this.phDropTarget.nativeElement.addEventListener('mouseup', this.preventDefault, {
        passive: false,
      });
    }
  }

  enableClick() {
    if (!this.disabledClick) {
      return;
    }
    this.disabledClick = false;
    this.phDropTarget.nativeElement.removeEventListener('touchend', this.preventDefault);
    this.phDropTarget.nativeElement.removeEventListener('mouseup', this.preventDefault);
  }

  preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  }

  close() {
    this.dropInstance.close();
  }

  open() {
    this.dropInstance.open();
  }
}
